import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { NimbusFilterSummaryBase } from '@nimbus-library/features/shared/components/nimbus-grid-filter/nimbus-filter-summary-base';
import { InputValidator } from '@nimbus-library/features/shared/components/material/input-validator';

@Component({
  standalone: false,
  selector: 'nimbus-filter-summary-input',
  templateUrl: './nimbus-filter-summary-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NimbusFilterSummaryInputComponent extends NimbusFilterSummaryBase {
  @Input() public inputValidator: InputValidator;
  @Input() public ngControl: NgControl;
  @Input() public warningMessage: string;

  public get formControl(): FormControl {
    return this.ngControl.control as FormControl;
  }
}
